var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey__situation"},[_c('div',{staticClass:"survey__situation__body"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2),(_vm.counter)?_c('test-counter',{attrs:{"number":_vm.number,"total":_vm.total}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }